module.exports = __webpack_public_path__ + "Flag-450.71637a4ca462cacf12afdc90e97ef761.svg";